<div #headerDiv class="fluid-container sticky-top">
    <nav class="navbar navbar-expand-xl bg-white navbar-light shadow-sm">
        <!-- regular size logo desktop / mobile view -->
        <div
            *ngIf="!(hasWideLogoUsed$ | async)"
            class="container container-wide"
        >
            <div class="menu-logos ps-3 ps-md-0 d-flex row flex-row">
                <a
                    *ngIf="communityIsValid | async"
                    class="navbar-brand my-auto me-3 col"
                    [routerLink]="'/' + communityCode + '/home'"
                    (click)="navbarCollapsed = true"
                >
                    <img
                        id="menuLogo"
                        height="40"
                        [attr.src]="'menu-brand-logo' | cmsImageSrc | async"
                        [attr.alt]="'menu-brand-logo' | cmsImageAlt | async"
                    />
                </a>
                <div class="d-flex flex-md-row col flex-column community-logo">
                    <a
                        *ngIf="
                            (communityIsValid | async) &&
                            !(hasWideLogoForMobileUsed$ | async)
                        "
                        class="navbar-brand"
                        [routerLink]="'/' + communityCode + '/home'"
                        (click)="navbarCollapsed = true"
                    >
                        <img
                            [attr.src]="'menu-logo' | cmsImageSrc | async"
                            [attr.alt]="'menu-logo' | cmsImageAlt | async"
                        />
                    </a>
                    <a
                        class="navbar-brand ms-md-3 ms-0"
                        *ngIf="
                            contentService.valueExists('menu-logo-second')
                                | async
                        "
                    >
                        <img
                            [attr.src]="
                                'menu-logo-second' | cmsImageSrc | async
                            "
                            [attr.alt]="
                                'menu-logo-second' | cmsImageAlt | async
                            "
                        />
                    </a>
                </div>
            </div>
            <button
                class="navbar-toggler"
                [hidden]="!showMenuLinks"
                type="button"
                (click)="navbarCollapsed = !navbarCollapsed"
                [attr.aria-expanded]="!navbarCollapsed"
                aria-controls="navbarContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
                <p class="my-2 small">メニュー</p>
            </button>

            <div
                class="navbar-collapse"
                [ngbCollapse]="navbarCollapsed"
                id="navbarContent"
            >
                <nav
                    [hidden]="!showMenuLinks"
                    *ngIf="communityIsValid | async"
                    class="navbar-nav ms-auto"
                >
                    <ng-container *ngFor="let item of items$ | async">
                        <a
                            *ngIf="!item.children"
                            class="nav-item nav-link text-uppercase"
                            [routerLink]="'/' + communityCode + item.link"
                            id="{{ item.id }}"
                            [routerLinkActive]="['active']"
                            (click)="navbarCollapsed = true"
                        >
                            {{ item.cmsKey | cmsText | async }}
                        </a>
                        <div
                            *ngIf="item.children"
                            ngbDropdown
                            placement="bottom-right"
                            class="d-inline-block"
                        >
                            <button
                                class="dropdown-item nav-link"
                                id="moreInfoDropdown"
                                ngbDropdownToggle
                            >
                                {{ item.cmsKey | cmsText | async }}
                            </button>
                            <div
                                ngbDropdownMenu
                                aria-labelledby="moreInfoDropdown"
                            >
                                <a
                                    *ngFor="let childItem of item.children"
                                    class="dropdown-item"
                                    [routerLink]="'/' + childItem.url"
                                    (click)="moreInfoDropdownClick()"
                                    >{{ childItem.cmsKey | cmsText | async }}</a
                                >
                            </div>
                        </div>
                    </ng-container>
                </nav>
            </div>
        </div>

        <!-- wide logo desktop view -->
        <div
            *ngIf="hasWideLogoUsed$ | async"
            class="d-none d-xl-block container-xl"
        >
            <div class="menu-logos ps-3 ps-md-0 d-flex row flex-row">
                <a
                    *ngIf="communityIsValid | async"
                    class="navbar-brand my-auto me-3 col"
                    [routerLink]="'/' + communityCode + '/home'"
                    (click)="navbarCollapsed = true"
                >
                    <img
                        id="menuLogo"
                        height="40"
                        [attr.src]="'menu-brand-logo' | cmsImageSrc | async"
                        [attr.alt]="'menu-brand-logo' | cmsImageAlt | async"
                    />
                </a>
                <div class="d-flex flex-md-row flex-column community-logo">
                    <a
                        *ngIf="communityIsValid | async"
                        class="navbar-brand-wide d-lg-block d-none"
                        [routerLink]="'/' + communityCode + '/home'"
                        (click)="navbarCollapsed = true"
                    >
                        <img
                            [attr.src]="'menu-logo-wide' | cmsImageSrc | async"
                            [attr.alt]="'menu-logo-wide' | cmsImageAlt | async"
                        />
                    </a>
                    <a
                        class="navbar-brand ms-md-3 ms-0"
                        *ngIf="
                            contentService.valueExists('menu-logo-second')
                                | async
                        "
                    >
                        <img
                            [attr.src]="
                                'menu-logo-second' | cmsImageSrc | async
                            "
                            [attr.alt]="
                                'menu-logo-second' | cmsImageAlt | async
                            "
                        />
                    </a>
                </div>
            </div>
            <button
                class="navbar-toggler"
                [hidden]="!showMenuLinks"
                type="button"
                (click)="navbarCollapsed = !navbarCollapsed"
                [attr.aria-expanded]="!navbarCollapsed"
                aria-controls="navbarContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
                <p class="my-2 small">メニュー</p>
            </button>

            <div
                class="navbar-collapse"
                [ngbCollapse]="navbarCollapsed"
                id="navbarContent"
            >
                <nav
                    [hidden]="!showMenuLinks"
                    *ngIf="communityIsValid | async"
                    class="navbar-nav ms-auto"
                >
                    <ng-container *ngFor="let item of items$ | async">
                        <a
                            *ngIf="!item.children"
                            class="nav-item nav-link text-uppercase"
                            [routerLink]="'/' + communityCode + item.link"
                            id="{{ item.id }}"
                            [routerLinkActive]="['active']"
                            (click)="navbarCollapsed = true"
                        >
                            {{ item.cmsKey | cmsText | async }}
                        </a>
                        <div
                            *ngIf="item.children"
                            ngbDropdown
                            placement="bottom-right"
                            class="d-inline-block"
                        >
                            <button
                                class="dropdown-item nav-link"
                                id="moreInfoDropdown"
                                ngbDropdownToggle
                            >
                                {{ item.cmsKey | cmsText | async }}
                            </button>
                            <div
                                ngbDropdownMenu
                                aria-labelledby="moreInfoDropdown"
                            >
                                <a
                                    *ngFor="let childItem of item.children"
                                    class="dropdown-item"
                                    [routerLink]="'/' + childItem.url"
                                    (click)="moreInfoDropdownClick()"
                                    >{{ childItem.cmsKey | cmsText | async }}</a
                                >
                            </div>
                        </div>
                    </ng-container>
                </nav>
            </div>
        </div>

        <!-- wide logo mobile view -->
        <div
            *ngIf="hasWideLogoUsed$ | async"
            class="container container-lg-none container-wide"
        >
            <div class="menu-logos ps-3 ps-md-0 d-flex row flex-row">
                <a
                    *ngIf="communityIsValid | async"
                    class="navbar-brand my-auto me-3 col"
                    [routerLink]="'/' + communityCode + '/home'"
                    (click)="navbarCollapsed = true"
                >
                    <img
                        id="menuLogo"
                        height="40"
                        [attr.src]="'menu-brand-logo' | cmsImageSrc | async"
                        [attr.alt]="'menu-brand-logo' | cmsImageAlt | async"
                    />
                </a>
                <div class="d-flex flex-md-row flex-column community-logo">
                    <!-- default community logo -->
                    <a
                        *ngIf="
                            (communityIsValid | async) &&
                            !(hasWideLogoForMobileUsed$ | async)
                        "
                        class="navbar-brand"
                        [routerLink]="'/' + communityCode + '/home'"
                        (click)="navbarCollapsed = true"
                    >
                        <img
                            [attr.src]="'menu-logo' | cmsImageSrc | async"
                            [attr.alt]="'menu-logo' | cmsImageAlt | async"
                        />
                    </a>
                    <!-- alternative logo for a community that has a wide logo in header, only shows on md or smaller breakpoints -->
                    <a
                        *ngIf="
                            (communityIsValid | async) &&
                            (hasWideLogoForMobileUsed$ | async)
                        "
                        class="navbar-brand-wide d-block d-xl-none"
                        [routerLink]="'/' + communityCode + '/home'"
                        (click)="navbarCollapsed = true"
                    >
                        <img
                            [attr.src]="
                                'menu-logo-wide-mobile' | cmsImageSrc | async
                            "
                            [attr.alt]="
                                'menu-logo-wide-mobile' | cmsImageAlt | async
                            "
                        />
                    </a>
                    <!-- secondary logo, only use it when it's necessary -->
                    <a
                        class="navbar-brand ms-md-3 ms-0"
                        *ngIf="
                            contentService.valueExists('menu-logo-second')
                                | async
                        "
                    >
                        <img
                            [attr.src]="
                                'menu-logo-second' | cmsImageSrc | async
                            "
                            [attr.alt]="
                                'menu-logo-second' | cmsImageAlt | async
                            "
                        />
                    </a>
                </div>
            </div>
            <button
                class="navbar-toggler"
                [hidden]="!showMenuLinks"
                type="button"
                (click)="navbarCollapsed = !navbarCollapsed"
                [attr.aria-expanded]="!navbarCollapsed"
                aria-controls="navbarContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
                <p class="my-2 small">メニュー</p>
            </button>

            <div
                class="navbar-collapse"
                [ngbCollapse]="navbarCollapsed"
                id="navbarContent"
            >
                <nav
                    [hidden]="!showMenuLinks"
                    *ngIf="communityIsValid | async"
                    class="navbar-nav ms-auto"
                >
                    <ng-container *ngFor="let item of items$ | async">
                        <a
                            *ngIf="!item.children"
                            class="nav-item nav-link text-uppercase"
                            [routerLink]="'/' + communityCode + item.link"
                            id="{{ item.id }}"
                            [routerLinkActive]="['active']"
                            (click)="navbarCollapsed = true"
                        >
                            {{ item.cmsKey | cmsText | async }}
                        </a>
                        <div
                            *ngIf="item.children"
                            ngbDropdown
                            placement="bottom-right"
                            class="d-inline-block"
                        >
                            <button
                                class="dropdown-item nav-link"
                                id="moreInfoDropdown"
                                ngbDropdownToggle
                            >
                                {{ item.cmsKey | cmsText | async }}
                            </button>
                            <div
                                ngbDropdownMenu
                                aria-labelledby="moreInfoDropdown"
                            >
                                <a
                                    *ngFor="let childItem of item.children"
                                    class="dropdown-item"
                                    [routerLink]="'/' + childItem.url"
                                    (click)="moreInfoDropdownClick()"
                                    >{{ childItem.cmsKey | cmsText | async }}</a
                                >
                            </div>
                        </div>
                    </ng-container>
                </nav>
            </div>
        </div>
    </nav>
</div>
<div class="fixed-top">
    <span
        class="badge badge-info ms-4"
        *ngIf="authService.user$ | async; let admin"
    >
        {{ admin.name }}
    </span>
</div>
